import { LAYERS } from 'shared';
import { Tile as TileLayer } from 'ol/layer';
import TileWMS from 'ol/source/TileWMS';
import { createAuthenticatedTileLoader } from '../../services/agroImageryService';

export default class BlockPlotProductLayer {
    constructor(map, user) {
        this.map = map;
        this.init(user);
    }

    init(user) {
        this.layer = new TileLayer({
            title: 'NDVI',
            type: LAYERS.TYPES.BLOCK_PLOT_PRODUCT,
            visible: false,
            displayInLayerSwitcher: true,
        });
    }

    getLayer() {
        return this.layer;
    }

    update(layer) {
        if (!layer.visible || !layer.product) {
            if (this.tileLoader) this.tileLoader.dispose();
            this.layer.set('product', null);
            this.layer.setVisible(false);
            return;
        }

        if (layer.product !== this.layer.get('product')) {
            if (this.tileLoader) this.tileLoader.dispose();
            this.tileLoader = null;
            const product = layer.product;
            let options;
            if (product.wmsUrl) {
                this.tileLoader = createAuthenticatedTileLoader();
                options = {
                    url: product.wmsUrl,
                    tileLoadFunction: this.tileLoader.tileLoadFunction,
                    params: { LAYERS: product.url, FORMAT: 'image/png' },
                };
            } else {
                const match = product.url && product.url.match('^([^:]*):(.*)$');
                if (!match) {
                    this.layer.setVisible(false);
                    return;
                }
                options = {
                    url: `/geoserver/${match[1]}/wms?service=WMS`,
                    crossOrigin: 'anonymous',
                    params: { LAYERS: product.url, FORMAT: 'image/png' },
                };
            }
            this.layer.setSource(new TileWMS(options));
            this.layer.set('product', product);
        }
        this.layer.setVisible(true);
    }
}
